import { Base } from '../base-component';
import './image-with-large-text-left.component.scss';

export class ImageWithLargeTextLeft extends Base {

	constructor(element: Element){

		super(element);

	}

	init(){

	}

	bindEvents() {

	}

}


// WEBPACK FOOTER //
// ./components/image-with-large-text-left/image-with-large-text-left.component.ts